import React, { useState } from 'react';
import { X } from 'lucide-react';
import { gallery } from '../data/mock';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-32 bg-[#000000] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-gold-400 text-xs font-medium tracking-[0.3em] uppercase mb-6 block">
            Naši trenuci
          </span>
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-light text-gold-400 mb-6">
            <span className="text-gold-gradient">Galerija</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold-400 mx-auto mb-8" />
          <p className="text-white/50 max-w-2xl mx-auto text-lg font-light">
            Pogledajte delove naših nastupa i upoznajte članove benda
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gallery.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden cursor-pointer aspect-[4/5]"
              onClick={() => setSelectedImage(image)}
            >
              {/* Frame */}
              <div className="absolute inset-4 border border-gold-400/0 group-hover:border-gold-400/30 transition-all duration-500 z-10 pointer-events-none" />
              
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 filter grayscale-[30%] group-hover:grayscale-0"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#000000] via-[#000000]/20 to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" />
              
              {/* Hover Content */}
              <div className="absolute inset-0 flex items-end p-8">
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-[#000000]/98 backdrop-blur-xl flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-8 right-8 text-gold-400/50 hover:text-gold-400 transition-colors duration-300"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="absolute -inset-4 border border-gold-400/20" />
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
